<template>
  <v-card id="tableCard" ref="tableCard">
    <TransferDialog v-if="showTransferDialog" :table="table" :show="showTransferDialog" :item="transferDialogProperties.item"
                    @close="showTransferDialog = false"></TransferDialog>
    <v-card-title>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table dense :headers="headers" :items="nfts" :items-per-page="50" :loading="moreToLoad" :loading-text="'Loading... Please wait'"
                  :search="search" :footer-props="{'items-per-page-options': [10, 50, 100, 1000, -1]}" multi-sort>
      <template v-slot:item.sendButton="{ item }">
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="openTransferDialog(item)" v-bind="attrs" v-on="on">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
            <span>Transfer {{item.type}}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import TransferDialog from "../../../mixins/TransferDialog";

export default {
  name: 'STARInventoryTable',
  components: {TransferDialog},
  props: {
    username: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadAll();
  },
  computed: {
    // TODO: Expand to multiples
    transferDialogProperties() {
      if (this.selectedNfts.length === 0) {
        return {
          item: {
            _id: 0
          },
        }
      }
      else {
        return {
          item: this.selectedNfts[0],
        }
      }
    }
  },
  data() {
    return {
      nfts: [],
      selectedNfts: [],
      moreToLoad: false,
      table: "STAR",
      showTransferDialog: false,
      headers: [
        {
          value: "_id",
          filterable: true,
          text: "ID"
        },
        {
          value: "account",
          filterable: true,
          text: "Owner"
        },
        {
          value: "type",
          filterable: true,
          text: "Type"
        },
        {
          value: "class",
          filterable: true,
          text: "Class"
        },
        {
          value: "stats",
          filterable: true,
          text: "Stats"
        },
        {
          value: "previousAccount",
          filterable: true,
          text: "Previous Owner"
        },
        {
          value: "sendButton",
          filterable: false,
          sortable: false,
          text: "Actions"
        }
      ],
      search: ""
    }
  },
  methods: {
    fetchTokens(contract, table, limit, offset) {
      this.$ssc.find(
          contract,
          table,
          {
            account: this.username
          }, limit, offset, [], (err, result) => {
            result.forEach(item => {
              delete item.ownedBy;
              delete item.lockedTokens;
              delete item.previousOwnedBy;
              item.type = item.properties.type;
              item.class = item.properties.class;
              item.stats = item.properties.stats;
              delete item.properties;
              this.nfts.push(item);
            });
            return result;
          }).then(tokens => {
        if (tokens.length === 1000) {
          offset += 1000;
          this.moreToLoad = true;
          this.fetchTokens(contract, table, limit, offset);
        }
        else {
          this.moreToLoad = false;
        }
      });
    },
    loadAll() {
      this.moreToLoad = true;
      this.fetchTokens("nft", "STARinstances", 1000, 0);
    },
    openTransferDialog(nft) {
      this.selectedNfts = [nft]
      this.showTransferDialog = true;
    }
  }
}
</script>